module.exports = __webpack_public_path__ + "static/img/loginBanner.4a0eeae1.png";